import { createElementBlock as c, openBlock as o, createElementVNode as r, defineComponent as l, resolveComponent as p, createBlock as a } from "vue";
import s from "./InputIcon-DYMgHv8r.js";
import { _ as i } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function u(e, n) {
  return o(), c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    r("path", {
      "fill-rule": "evenodd",
      d: "M2 3.5A1.5 1.5 0 0 1 3.5 2h1.148a1.5 1.5 0 0 1 1.465 1.175l.716 3.223a1.5 1.5 0 0 1-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 0 0 6.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 0 1 1.767-1.052l3.223.716A1.5 1.5 0 0 1 18 15.352V16.5a1.5 1.5 0 0 1-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 0 1 2.43 8.326 13.019 13.019 0 0 1 2 5V3.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const d = l({
  components: { InputIcon: s },
  setup: () => ({ PhoneIcon: u })
});
function m(e, n, f, _, I, h) {
  const t = p("InputIcon");
  return o(), a(t, {
    type: "tel",
    icon: e.PhoneIcon
  }, null, 8, ["icon"]);
}
const B = /* @__PURE__ */ i(d, [["render", m]]);
export {
  B as default
};
//# sourceMappingURL=InputTel-Btcgb43z.js.map
